//import PhoneInput  from 'react-phone-number-input'
//import { formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input'
//import 'react-phone-number-input/style.css'
import React, { useState } from 'react';

import CandidateAcceptedFolderComponent from './CandidateAcceptedFolderComponent';
import CandidateFolderComponent from './CandidateFolderComponent';
import CandidateLogInComponent from './CandidateLogInComponent';
import CandidateNavbarComponent from './CandidateNavbarComponent';

const CandidateComponent = () => {
  const [phoneValue, setPhoneValue] = useState('');
  const [step, setStep] = useState(0);

  const [candidates, setCandidates] = useState([]);

  let content = <></>;

  switch (step) {
    case 1:
      //todo fetch data accordingly
      content = <CandidateFolderComponent candidate={candidates} setCandidates={setCandidates} setStep={setStep} />;
      break;
    case 2:
      //todo fetch data accordingly
      content = (
        <CandidateAcceptedFolderComponent candidate={candidates} setCandidates={setCandidates} setStep={setStep} />
      );
      break;
    case 0:
    default:
      content = <CandidateLogInComponent phoneValue={phoneValue} setPhoneValue={setPhoneValue} setStep={setStep} />;
  }

  return (
    <>
      <CandidateNavbarComponent connected={false} />
      <div className="align-items-center justify-content-center mt-5">{content}</div>
    </>
  );
};

export default CandidateComponent;
